import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

@Component({
    selector: 'app-video-dialog',
    templateUrl: './video-dialog.component.html',
    styleUrls: ['./video-dialog.component.scss'],
    standalone: false
})
export class VideoDialogComponent implements OnInit {
  @ViewChild('bVideo', { static: true }) bunnyVideo: any;
  @ViewChild('replayButton', { static: true }) replay: any;
  showReplay = false;
  
  constructor( public dialog: MatDialog) { }

  ngOnInit(): void {
  }

  toggleVideo() {
    this.showReplay = false;
    this.bunnyVideo.nativeElement.play();
  }

  vidEnded() {
    this.showReplay = true;
  }

  closeDialog() {
    this.dialog.closeAll();
  }
}
